<template>
  <gg-card>
    <gg-card-header>
      Click Breakdown
    </gg-card-header>
    <gg-card-text>
      <v-row>
          <v-col cols="12">
            <v-data-table :headers="headers" :items="items" :loading="loading"></v-data-table>
          </v-col>
        </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClickBreakdown',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      headers: [
        { text: 'Campaign Code', value: 'campaign_code' },
        { text: 'Sales', value: 'sales' },
        { text: 'Gross Clicks', value: 'gross_clicks' },
        { text: 'Unique Clicks', value: 'unique_clicks' },
      ]
    }
  },
  computed: mapGetters({
    loading: 'affiliates/loadingStatistics'
  })
}
</script>

<style scoped>

</style>
